import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ;

const apiMainPage = axios.create({
  baseURL: API_BASE_URL,
});

export const suryaGroupApi = {
  FreeEstimationReq: (data) => apiMainPage.post("/surya-group/free-estimation-request/create", data), 
 
};